var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckMark = function SvgCheckMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "check mark",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m16.072 7.46-5.81 7.749a.38.38 0 0 1-.273.148.38.38 0 0 1-.294-.11l-3-3a1.125 1.125 0 0 0-1.59 1.592l3 3a2.627 2.627 0 0 0 3.955-.28l5.812-7.75a1.124 1.124 0 0 0-.226-1.574 1.126 1.126 0 0 0-1.575.225",
    clipRule: "evenodd"
  })));
};
export default SvgCheckMark;